export default "__VITE_ASSET__2438ce32__"